
<div v-if="faults > 0">
    <div class="fault-label">
        {{ label }}
    </div>
    <div class="fault-count" :class="background">
        <span >{{ confirmed }}/{{faults}}</span>
    </div>
</div>
